/**
 * @file The ONE place that decides which host serves a Xoe conversation (P6.1).
 * @module api/xoe/xoeBaseUrl
 *
 * ═══ THE FLAG GAP THIS CLOSES ═════════════════════════════════════════════════
 */

import { ENV } from '../../config/runtimeEnv';

/**
 * True when this deployment should address the xoe-agent service.
 *
 * Kept as a separate export so a caller can branch on it WITHOUT re-deriving the
 * condition — a second copy of "is streaming on?" is the thing that drifts.
 */
export const isXoeAgentEnabled = (): boolean =>
	ENV.VITE_XOE_STREAMING_ENABLED === 'true' && !!ENV.VITE_XOE_AGENT_SERVER;

/**
 * The base URL for Xoe CONVERSATION endpoints (list, CRUD, messages, tools,
 * resolve-patient).
 *
 * Read at CALL TIME, never captured in a module-level `const`. The runtime config
 * is injected into `window.__ENV__` by nginx from a ConfigMap, and a module-level
 * capture would freeze whatever was present when the bundle first evaluated —
 * which is the whole reason `VITE_*` is not read directly anywhere in this app.
 */
export const xoeConversationBaseUrl = (): string =>
	isXoeAgentEnabled()
		? (ENV.VITE_XOE_AGENT_SERVER as string)
		: (ENV.VITE_HEALTHCARE_SERVER as string);
